import { useEffect, useState } from "react";
import { baseUrl } from "../utils/strings";
import { fetchData } from "../utils/api";

const useCountryData = ({ setMessage }) => {
  const [countries, setCountries] = useState([]);
  const [countryName, setCountryName] = useState("mozambique");

  const getCountries = async () => {
    const data = await fetchData(`${baseUrl}/api/countries`, setMessage);
    setCountries(data);
  };

  useEffect(() => {
    getCountries();
    // Bypass linting as the required dependency cause unnecessary re-rendering
    // eslint-disable-next-line
  }, []);

  return { countries, countryName, setCountryName };
};

export default useCountryData;
